import React, {useState} from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import ISA315ItGCTestStrategyListItem from './ISA315ItGCTestStrategyListItem';
import CreateEditITProcessModalWrapper from '../../../../../../../components/Common/EntityCrud/CreateEditITProcessModalWrapper';

// Removed unused imports: Fragment, useRef, useCallback

// Destructured props directly in the function signature for better readability
export default function ISA315ItGCTestStrategyList({
	bodyId,
	className = '',
	allIds: itProcessIds = [],
	engagementId,
	documentId,
	documentEngagementId,
	openRelateModal
}) {
	const [containerProps, setContainerProps] = useState({});
	const [showCreateEditEntityModal, setShowCreateEditEntityModal] = useState(false);

	const onCreateUpdate = (args) => {
		setContainerProps(args);
		setShowCreateEditEntityModal(true);
	};

	return (
		<StyledISA315ItGCTestStrategyList className={`StyledISA315ItGCTestStrategyList customScrollbar ${className}`}>
			{itProcessIds.map((itProcessId) => (
				<ISA315ItGCTestStrategyListItem
					openRelateModal={openRelateModal}
					engagementId={engagementId}
					documentId={documentId}
					documentEngagementId={documentEngagementId}
					key={itProcessId}
					itProcessId={itProcessId}
					bodyId={bodyId}
					onCreateUpdate={onCreateUpdate}
				/>
			))}
			{showCreateEditEntityModal && (
				<CreateEditITProcessModalWrapper
					entityId={containerProps.entityUId}
					showModal
					isEdit
					setShowModal={() => setShowCreateEditEntityModal(false)}
				/>
			)}
		</StyledISA315ItGCTestStrategyList>
	);
}

ISA315ItGCTestStrategyList.propTypes = {
	className: PropTypes.string,
	bodyId: PropTypes.number,
	allIds: PropTypes.arrayOf(PropTypes.number)
};

const StyledISA315ItGCTestStrategyList = styled.section`
	padding: 0 var(--px-5) var(--px-5) 0;
	margin-bottom: var(--px-20);
	max-height: var(--px-1110);
	@media only screen and (min-width: 1280px) and (max-width: 1366px) {
		max-height: var(--px-1140);
	}
	overflow-y: auto;
	overflow-x: hidden;
	.primary-entity__child-entity {
		width: var(--px-230);
		font-size: var(--px-12) !important;
		font-weight: 300 !important;
		&.ControlsGroup1 {
			padding-top: 0;
			& > .ellipses {
				margin: var(--px-5) 0;
			}
		}
		&.ControlsGroup2 {
			width: var(--px-210);
			padding-top: var(--px-32);
		}
	}
	.motif-accordion: first-child {
		margin-top: 0 !important;
	}
`;
